// extracted by mini-css-extract-plugin
export default {"container":"XG-z","innerContainer":"YG-z","multipleLines":"ZG-z","heading":"_G-z","content":"aH-z","linkColor":"bH-z"};